export enum VoucherHolderType {    
    // Unknown = 0,
    StandardVoucher = 1,
    FamilyVoucher = 2,
    Unknown = 5
}